import { client } from "./graphql/client"
import { formatApolloError } from "./graphql/error";
import {reprocessBridgeStatusKyb} from "./graphql/kyb/mutations";

export const kybDataProvider = {

    create: async (resource, params) => {
        const { customerId } = params

        try {
            const result = await client.mutate({
                mutation: reprocessBridgeStatusKyb,
                variables: {
                    customerId
                }
            });

            const response = result.data

            return {
                data: {
                    id: customerId,
                    result: response
                }
            }
        } catch (e) {
            return Promise.resolve({
                data: {
                    id: -1,
                    error: formatApolloError(e)
                }
            });
        }
    }
}